(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:RecomendacaoSemeaduraCtrl
   * @description
   * # RecomendacaoSemeaduraCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('RecomendacaoSemeaduraNewCtrl', RecomendacaoSemeaduraController);

  /**
   * RecomendacaoSemeaduraController dependencies
   * @type {Array}
   */
  RecomendacaoSemeaduraController.$inject = [
    '$scope',
    '$rootScope',
    '$location',
    'Flash',
    'AtividadesService',
    'ItensService',
    '$q',
    'LoadingService',
    'MessagesService',
    'RecomendacoesSemeaduraService',
    '$routeParams',
    'RecomendacoesSemeaduraObjectService',
    'GoogleMapsService',
    'MapaService',
    '$timeout',
    'ColorService',
    '$filter',
    'SafrasService',
    'PeriodosService',
    'filterFilter',
    'ParametrosService',
    'UnidadesService',
    'EmpreendimentosService'
  ];

  /**
   * RecomendacaoSemeaduraController declaration
   */
  // eslint-disable-next-line max-lines-per-function, max-params
  function RecomendacaoSemeaduraController($scope, $rootScope, $location, Flash, AtividadesService, ItensService,
    $q, LoadingService, MessagesService, RecomendacoesSemeaduraService, $routeParams,
    RecomendacoesSemeaduraObjectService, GoogleMapsService, MapaService, $timeout, ColorService,
    $filter, SafrasService, PeriodosService, filterFilter, ParametrosService, UnidadesService, EmpreendimentosService) {
    const vm = this;
    const id = $routeParams.id;
    const printRecomedacao = $routeParams.printRecomedacao;

    //////////////////////////////////////////
    // Controller data

    // main data container
    vm.data = {
      situacao: 'aberto',
      status: 'rascunho',
      propriedade: null,
      safra: null,
      periodo: null,
      cultura: null,
      rendimento_minimo: null,
      rendimeno_maximo: null,
      espacamento: '',
      densidade: '',
      area_remontes: '',
      quantidade: '',
      regulagem: '',
      regulagem_adubacao: '',
      glebas: [],
      adubacao: [],
      tratamentos: [],
      calculo_margem_seguranca: false,
      observacao: ''
    };
    // Distinct Colors
    const listColors = [
      '#e6194B',
      '#3cb44b',
      '#4363d8',
      '#f58231',
      '#911eb4',
      '#f032e6',
      '#bfef45',
      '#fabebe',
      '#469990',
      '#9A6324',
      '#fffac8',
      '#aaffc3',
      '#808000',
      '#ffd8b1',
      '#000075',
      '#a9a9a9',
      '#800000',
      '#42d4f4',
      '#ffffff',
      '#000000'
    ];
    // current form tab
    vm.activeTab = 0;
    // list holders
    vm.propriedades = [];
    vm.safras = [];
    vm.periodos = [];
    vm.culturas = [];
    vm.nao_cliente_agrogestao = $scope.$root.parametros.nao_cliente_agrogestao;
    vm.cultivares = [];
    vm._cultivaresKey = null;
    vm.empreendimentos_periodos = [];
    vm.cultivaresDestino = [];
    vm.cultivaresTratamento = [];
    vm.cultivaresDestinoTratamento = [];
    vm.adubos = [];
    // temporary placeholder for new gleba
    vm.tempGleba = null;
    // temporary placeholder for new adubação
    vm.tempAdubacao = {
      gleba: null,
      adubo: null,
      dose: null,
      total: null
    };
    // temporary placeholder for new tratamento
    vm.tempTratamento = null;
    // controls calendar options
    vm.datePickerOptions = {
      showWeeks: false
    };
    vm.popupData = {
      openedDataInicio: false,
      openedDataFim: false,
      format: 'dd/MM/yyyy'
    };
    // map related variables
    vm.recMap = null;
    vm.cultivarColors = {};
    vm.mapLegend = [];
    vm.glebaMarkers = {};
    vm.editGlebaId = false;
    vm.editAduboId = false;
    vm.editTratementoId = false;
    vm.logo = null;
    vm.isCulturaPorUnidade = false;
    vm.reducedInsumos = [];
    vm.svgPolygons = '';

    //////////////////////////////////////////
    // Bindable methods
    vm.validTab = validTab;
    vm.openPopupData = openPopupData;
    vm.saveGleba = saveGleba;
    vm.saveAdubacao = saveAdubacao;
    vm.mainSaveDisabled = mainSaveDisabled;
    vm.addGlebaDisabled = addGlebaDisabled;
    vm.addAduboDisabled = addAduboDisabled;
    vm.calcDuracao = calcDuracao;
    vm.calcDataFim = calcDataFim;
    vm.calcDensidade = calcDensidade;
    vm.calcColheita = calcColheita;
    vm.calcRegulagem = calcRegulagem;
    vm.calcRegulagemAdubos = calcRegulagemAdubos;
    vm.calcQuantidade = calcQuantidade;
    vm.calcQuantidadeTotal = calcQuantidadeTotal;
    vm.calcQuantidadeTotalAdubo = calcQuantidadeTotalAdubo;
    vm.save = save;
    vm.deleteGleba = deleteGleba;
    vm.deleteAdubo = deleteAdubo;
    vm.glebaDescricao = glebaDescricao;
    vm.areaExceeded = areaExceeded;
    vm.createMap = createMap;
    vm.changeCultura = changeCultura;
    vm.searchCultivares = searchCultivares;
    vm.editGleba = editGleba;
    vm.editAdubo = editAdubo;
    vm.cancelEditGleba = cancelEditGleba;
    vm.cancelEditAdubo = cancelEditAdubo;
    vm.sortedGlebas = sortedGlebas;
    vm.shouldActiveTab = shouldActiveTab;
    vm.listCultivaresParaTratar = listCultivaresParaTratar;
    vm.changeCobertura = changeCobertura;
    vm.totalInsumoPorCultivar = totalInsumoPorCultivar;
    vm.checkTratamentosCultivares = checkTratamentosCultivares;
    vm.isEditingGleba = isEditingGleba;
    vm.cultivarMouseOver = cultivarMouseOver;
    vm.cultivarMouseOut = cultivarMouseOut;
    vm.aduboAreaExceeded = aduboAreaExceeded;
    vm.aduboGlebaDescricao = aduboGlebaDescricao;
    vm.validateDataFim = validateDataFim;
    vm.getPeriodosByEmpreedimentos = getPeriodosByEmpreedimentos;
    //////////////////////////////////////////
    // Function declarations

    /**
     * Returns wether all tab-specific properties within the form are valid
     * @param {String} name tab name
     * @return {Boolean}
     */

    function validTab(name) {
      if (name === 'parametros') {
        let requiredParams = ['safra', 'cultura', 'rendimento_minimo', 'rendimento_maximo'];

        if (vm.data.status === 'publicado') {
          requiredParams.push('periodo');
        }
        if (!vm.data.cobertura) {
          requiredParams = requiredParams.concat([
            'espacamento', 'densidade', 'quantidade', 'regulagem', 'regulagem_adubacao'
          ]);
        }
        return requiredParams
          .every(function(param) {
            return $scope.recForm[param] && $scope.recForm[param].$valid;
          });
      } else if (name === 'glebas') {
        return vm.data.glebas.length > 0;
      } else if (name === 'adubacao') {
        return vm.data.adubacao.length > 0;
      } else if (name === 'tratamento') {
        return RecomendacoesSemeaduraService.validarTratamentoDeSementes(vm.data);
      }

      return false;
    }

    /**
     * Opens datepicker popup
     * @param {String} popup popup name
     */
    function openPopupData(popup) {
      vm.popupData[popup] = true;
    }

    /**
     * Adds configured gleba to list of glebas
     */
    // eslint-disable-next-line max-lines-per-function
    function saveGleba() {
      if (!vm.validateDataFim(vm.tempGleba)) {
        return;
      }
      const gleba = angular.copy(vm.tempGleba);
      const original = _.find(vm.data.glebas, {
        _id: vm.editGlebaId
      });
      const index = vm.data.glebas.indexOf(original);
      vm.calcDensidade(gleba);
      vm.calcColheita(gleba);
      if (vm.editGlebaId !== false) {
        const markers = vm.glebaMarkers[original.gleba._id];
        if (markers) {
          vm.glebaMarkers[original.gleba._id].setMap(null);
        }
        gleba._edit = false;
        vm.data.glebas.splice(index, 1, gleba);
        vm.editGlebaId = false;
      } else {
        vm.data.glebas.push(gleba);
      }

      vm.mapLegend.length = 0;
      changeGlebaColor(gleba);

      vm.calcQuantidadeTotalAdubo('all');
      vm.listCultivaresParaTratar();
      if (gleba.ts === 'tsi') {
        vm.changeCultura(vm.data.cultura, TRATAMENTO_SEMENTE);
      }

      resetTempGleba();
    }

    /**
     * Adds configured adubo to adubação list
     */
    function saveAdubacao() {
      if (vm.editAduboId !== false) {
        saveEditAdubacao();
      } else if (vm.tempAdubacao.gleba) {
        const adubo = {
          gleba: vm.tempAdubacao.gleba.gleba,
          adubo: vm.tempAdubacao.adubo,
          dose: vm.tempAdubacao.dose,
          total: vm.tempAdubacao.total,
          area: vm.tempAdubacao.area
        };

        vm.calcQuantidadeTotalAdubo(adubo);
        vm.data.adubacao.push(adubo);
      } else {
        saveAdubacaoForAll();
      }

      vm.calcRegulagemAdubos();
      resetTempAdubo();
    }

    function getAvailableArea(gleba) {
      let areaTotalUsada = 0;
      if (vm.data.glebas.length > 1) {
        areaTotalUsada = vm.data.glebas.reduce((somador, semeadura) => {
          if (semeadura.gleba.id === gleba.gleba.id) {
            return somador + +semeadura.area_aplicada;
          }
          return somador;
        }, 0);
      } else {
        areaTotalUsada = gleba.area_aplicada;
      }
      return parseFloat(areaTotalUsada);
    }

    /**
     * Adds configured adubo to adubação list for all configured glebas
     */
    function saveAdubacaoForAll() {
      _.uniqBy(vm.data.glebas, 'gleba.id').forEach(function(gleba) {
        const adubo = {
          gleba: gleba.gleba,
          adubo: vm.tempAdubacao.adubo,
          dose: vm.tempAdubacao.dose,
          total: vm.tempAdubacao.total,
          area: getAvailableArea(gleba)
        };
        if (adubo.area > 0) {
          vm.calcQuantidadeTotalAdubo(adubo);
          vm.data.adubacao.push(adubo);
        }
      });
    }

    /**
     * Replaces current adubo with newly changed one
     * @param       {Object} adubo configured adubo
     * @constructor
     */
    function saveEditAdubacao() {
      const adubo = angular.copy(vm.tempAdubacao);
      adubo._edit = false;
      adubo.gleba = adubo.gleba.gleba;
      vm.data.adubacao.splice(vm.editAduboId, 1, adubo);
      vm.editAduboId = false;
      vm.calcQuantidadeTotalAdubo(adubo);
    }

    /**
     * Returns wether all tabs are invalid
     * @return {Boolean}
     */
    function mainSaveDisabled() {
      return !(vm.validTab('parametros') && vm.validTab('glebas'));
    }

    /**
     * Returns wether a new gleba can be added
     * @return {Boolean}
     */
    function addGlebaDisabled() {
      const array = ['gleba', 'cultivar', 'area_aplicada', 'data_inicio', TRATAMENTO_SEMENTE, 'ciclo'];

      if (!vm.isCulturaPorUnidade && !vm.data.cobertura) {
        array.push('pms');
      }

      if (!vm.data.cobertura) {
        array.push('densidade');
        array.push('pg');
      } else {
        array.push('dose');
      }

      return !(array.reduce(function(prev, curr) {
        return prev && !!vm.tempGleba[curr];
      }, true)) || RepeatedGleba();
    }

    function RepeatedGleba() {
      const amountEqual = vm.data.glebas.filter(function(gleba) {
        return gleba.gleba.id === (vm.tempGleba.gleba || {}).id &&
          gleba.cultivar.item_id === (vm.tempGleba.cultivar || {}).item_id;
      }).length;

      if (amountEqual > 0) {
        // se houver alguma gleba adicionada repetida,
        // verifica se a que está sendo adicionada é uma edição ou uma nova
        return vm.editGlebaId === false;
      }
      return false;
    }

    /**
     * Returns wether a new adubo can be added
     * @return {Boolean}
     */
    function addAduboDisabled() {
      return !(['gleba', 'adubo', 'dose', 'area']
        .reduce(function(prev, curr) {
          if (curr === 'gleba') {
            return prev && true;
          }
          if (curr === 'area' && !vm.tempAdubacao.gleba) {
            return prev;
          }
          return prev && !!vm.tempAdubacao[curr];
        }, true)) || RepeatedAdubo();
    }

    function RepeatedAdubo() {
      const amountEqual = vm.data.adubacao.filter(function(adubo) {
        return adubo.gleba.id === ((vm.tempAdubacao.gleba || {}).gleba || {}).id &&
          adubo.adubo.id === (vm.tempAdubacao.adubo || {}).id;
      }).length;

      if (amountEqual > 0) {
        // se houver algum adubo adicionado repetido,
        // verifica se o que está sendo adicionado é uma edição ou um novo
        return vm.editAduboId === false;
      }
      return false;
    }

    /**
     * Calculates duration based on informed data
     * @param {Object} gleba gleba to be calculated
     */
    function calcDuracao(gleba) {
      if (gleba === 'all') {
        vm.data.glebas.map(function(rec) {
          calc(rec);
          return rec;
        });
        return;
      }
      calc(gleba);


      vm.calcDataFim(gleba);
      function calc(g) {
        g.duracao_min = (vm.data.rendimento_maximo && vm.data.rendimento_maximo > 0) ?
          (g.area_aplicada / vm.data.rendimento_maximo) : null;
        g.duracao_max = (vm.data.rendimento_minimo && vm.data.rendimento_minimo > 0) ?
          (g.area_aplicada / vm.data.rendimento_minimo) : null;
      }
    }

    /**
     * Calculates end date based on calcDuracao
     * @param {Object} gleba gleba to be calculated
     */
    function calcDataFim(gleba) {
      if (gleba === 'all') {
        vm.data.glebas.map(function(rec) {
          calc(rec);
          return rec;
        });
      } else {
        calc(gleba);
      }
      function calc(g) {
        g.data_fim_min = g.duracao_min !== null ? moment(g.data_inicio).add(g.duracao_min, 'day')
          .toDate() : null;
        g.data_fim_max = g.duracao_max !== null ? moment(g.data_inicio).add(g.duracao_max, 'day')
          .toDate() : null;
      }
    }

    function validateDataFim(gleba) {
      const internalErrorMessage = function(message, internalGleba) {
        MessagesService.alert(`${message}`);
        internalGleba.data_fim_max = null;
      };
      let ok = true;
      if (gleba.data_fim_min > gleba.data_fim_max) {
        ok = false;
        const message = `Data final máxima não pode ser maior que a data final mínima
          ${moment(gleba.data_fim_min).format('DD/MM/YYYY')}!`;
        internalErrorMessage(message, gleba);
      }
      if (gleba.data_fim_min < gleba.data_inicio) {
        ok = false;
        const message = `Data final máxima não pode ser menor que a data inicial
          ${moment(gleba.inicio).format('DD/MM/YYYY')}!`;
        internalErrorMessage(message, gleba);
      }
      return ok;
    }

    /**
     * Calculates end of cycle
     * @param {Object} gleba gleba to be calculated
     */
    function calcColheita(gleba) {
      if (gleba === 'all') {
        vm.data.glebas.map(function(rec) {
          calc(rec);
          return rec;
        });
      } else {
        calc(gleba);
      }

      function calc(g) {
        g.colheita = moment(g.data_inicio).add(g.ciclo, 'days')
          .toDate();
      }
    }

    /**
     * Calculates densidade corrigida
     * @param {*} gleba recommendation object or string "all"
     */
    function calcDensidade(gleba) {
      if (gleba === 'all') {
        vm.data.glebas.map(function(rec) {
          calc(rec);
          return rec;
        });
      } else {
        calc(gleba);
      }

      vm.calcRegulagem(gleba);
      vm.calcRegulagemAdubos();
      vm.calcQuantidade(gleba);

      function calc(g) {
        const fatorCorrecao = (vm.data.densidade / 100 * vm.data.area_remontes) + (vm.data.quantidade || 0);

        g.densidade_corrigida = RecomendacoesSemeaduraService.calculateDensidadeCorrigida({
          densidadeIdeal: g.densidade,
          pg: g.pg,
          fatorCorrecao: fatorCorrecao
        });
      }
    }

    /**
     * Calculates max/min regulagem
     * @param {*} gleba recommendation object or string "all"
     */
    function calcRegulagem(gleba) {
      if (gleba === 'all') {
        vm.data.glebas.map(function(rec) {
          calc(rec);
          return rec;
        });
      } else {
        calc(gleba);
      }

      function calc(g) {
        g.regulagem = RecomendacoesSemeaduraService.calculateRegulagem({
          densidadeCorrigida: g.densidade_corrigida,
          espacamento: vm.data.espacamento,
          distribuicaoRegulagem: vm.data.regulagem
        }, false);
        g.regulagem.minimaEmGramas = (g.regulagem.minima * g.pms) / 1000;
        g.regulagem.maximaEmGramas = (g.regulagem.maxima * g.pms) / 1000;
        g.regulagem.resultadoEmGramas = (g.regulagem.resultado * g.pms) / 1000;
      }
    }

    /**
     * Calculates max/min regulagem
     * @param {*} gleba recommendation object or string "all"
     */
    function calcRegulagemAdubos() {
      vm.data.adubacao.map(function(rec) {
        calc(rec);
        return rec;
      });

      function calc(a) {
        const convertionValue = UnidadesService.getMeasureUnitysFromDescription(a.adubo.unidade.descricao);
        const doseConvertida = a.dose * (convertionValue.reverseConversao || 1);
        a.regulagem_adubacao = RecomendacoesSemeaduraService.calculateRegulagem({
          densidadeCorrigida: doseConvertida,
          espacamento: vm.data.espacamento,
          distribuicaoRegulagem: vm.data.regulagem_adubacao
        }, true);
      }
    }

    /**
     * Calculates max/min amount
     * @param {*} gleba recommendation object or string "all"
     */
    function calcQuantidade(gleba) {
      if (gleba === 'all') {
        vm.data.glebas.forEach(function(rec) {
          calc(rec);
        });
      } else {
        calc(gleba);
      }

      vm.calcQuantidadeTotal(gleba);

      function calc(g) {
        if (vm.data.cobertura) {
          g.quantidade = {
            minima: g.dose,
            maxima: g.dose,
            resultado: g.dose
          };
        } else {
          g.quantidade = RecomendacoesSemeaduraService.calculateQuantidade({
            densidadeCorrigida: g.densidade_corrigida,
            pms: g.pms,
            isCorn: vm.isCulturaPorUnidade
          });
        }
      }
    }

    /**
     * Calculates total amount
     * @param {*} gleba recommendation object or string "all"
     */
    function calcQuantidadeTotal(gleba) {
      if (gleba === 'all') {
        vm.data.glebas.map(function(rec) {
          calc(rec);
          return rec;
        });
      } else {
        calc(gleba);
      }

      function calc(g) {
        g.total = RecomendacoesSemeaduraService.calculateQuantidadeTotal({
          quantidade: g.quantidade,
          taxaCorrecao: vm.data.quantidade,
          area: g.area_aplicada
        }, vm.data.calculo_margem_seguranca);
      }
    }

    /**
     * Calculates total amount
     * @param {*} gleba recommendation object or string "all"
     */
    function calcQuantidadeTotalAdubo(adubacao) {
      if (adubacao === 'all') {
        vm.data.adubacao.forEach(function(recAdubacao) {
          calc(recAdubacao);
        });
      } else {
        calc(adubacao);
      }

      function calc(obj) {
        obj.total = RecomendacoesSemeaduraService.calculateQuantidadeTotalAdubo({
          dose: obj.dose,
          taxaCorrecao: vm.data.quantidade,
          area: parseFloat(obj.area)
        });
      }
    }

    /**
     * saves recommendation
     */
    function saveRecommendation() {
      let operationResult;
      let msg = 'Recomendação criada com sucesso';
      LoadingService.showLoading();

      if (!id) {
        operationResult = RecomendacoesSemeaduraService.save(vm.data);
      } else {
        msg = 'Recomendação atualizada com sucesso';
        operationResult = RecomendacoesSemeaduraService.update(vm.data);
      }

      operationResult.then(function() {
        Flash.create('success', msg);
        $location.path('/recomendacoes_semeadura');
      }).catch(function(error) {
        try {
          MessagesService.alert(error.data.sem_empreendimento[0]);
        } catch (e) {
          MessagesService.alert('Falha ao salvar, tente novamente.');
        }
      })
        .finally(function() {
          LoadingService.hideLoading();
        });
    }

    function save() {
      if (!checkTratamentosCultivares()) {
        return;
      }

      if (!RecomendacoesSemeaduraService.validarTratamentoDeSementes(vm.data)) {
        MessagesService.confirm(
          'Existem dados referente ao tratamento de sementes incompletos, deseja salvar mesmo assim?'
        ).then(function() {
          saveRecommendation();
        });
      } else {
        saveRecommendation();
      }
    }

    /**
     * Deletes gleba from data object
     */
    function deleteGleba(gleba) {
      if (gleba.marker) {
        gleba.marker.setMap(null);
      }
      const adubos = vm.data.adubacao.filter(function(adubo) {
        return adubo.gleba.id === gleba.gleba.id;
      });
      adubos.forEach(function(adubo) {
        vm.data.adubacao.splice(vm.data.adubacao.indexOf(adubo), 1);
      });

      vm.data.glebas.splice(vm.data.glebas.indexOf(gleba), 1);

      vm.listCultivaresParaTratar();
    }

    /**
     * Deletes adubo from data object
     */
    function deleteAdubo(idx) {
      vm.data.adubacao.splice(idx, 1);
    }

    function glebaDescricao(gleba, area) {
      area = area || gleba.area_total;
      return `${gleba.descricao} (${$filter('number')(area)} ha)`;
    }

    function aduboGlebaDescricao(gleba) {
      return vm.glebaDescricao(gleba.gleba, gleba.area_aplicada);
    }

    function areaExceeded() {
      if (vm.tempGleba.gleba) {
        let sum = vm.data.glebas.reduce(function(last, current) {
          last += (current.gleba.id === vm.tempGleba.gleba.id && !current._edit) ? (+current.area_aplicada) : 0;
          return last;
        }, 0) || 0;
        sum += (+vm.tempGleba.area_aplicada) || 0;
        return (+vm.tempGleba.gleba.area_total) - sum < 0;
      }

      return false;
    }

    function aduboAreaExceeded() {
      if (vm.tempAdubacao.gleba) {
        let sum = vm.data.adubacao.reduce(function(last, current) {
          last += (current.gleba.id === vm.tempAdubacao.gleba.gleba.id && !current._edit) ? (+current.area) : 0;
          return last;
        }, 0) || 0;
        sum += (+vm.tempAdubacao.area) || 0;
        return (+vm.tempAdubacao.gleba.area_aplicada) - sum < 0;
      }

      return false;
    }

    function editGleba(gleba) {
      if (vm.editGlebaId !== gleba._id) {
        if (vm.editGlebaId !== false) {
          vm.data.glebas.filter(function(fGleba) {
            return fGleba._id === vm.editGlebaId;
          })[0]._edit = false;
        }

        vm.editGlebaId = gleba._id;
        gleba._edit = true;
        const glebaClone = angular.copy(gleba);
        glebaClone.area_aplicada = +glebaClone.area_aplicada;
        vm.tempGleba = glebaClone;
        vm.tempGleba.gleba = _.find(vm.data.propriedade.glebas, {
          id: vm.tempGleba.gleba.id
        });
        changeCultura(vm.data.cultura, glebaClone.ts);
      }
    }

    function editAdubo(index) {
      if (vm.editAduboId !== index) {
        if (vm.editAduboId !== false) {
          vm.data.adubacao[vm.editAduboId]._edit = false;
        }

        vm.editAduboId = index;
        vm.data.adubacao[index]._edit = true;
        const adubo = angular.copy(vm.data.adubacao[index]);
        adubo.gleba = vm.data.glebas.filter(function(gleba) {
          return adubo.gleba.id === gleba.gleba.id;
        })[0];
        adubo.dose = +adubo.dose;
        adubo.area = +adubo.area;
        adubo.gleba.areaAplicadaAcumulada = +adubo.area; // Para edição da Área
        vm.tempAdubacao = adubo;
      }
    }

    function cancelEditGleba() {
      vm.data.glebas.forEach(function(gleba) {
        gleba._edit = false;
      });
      vm.editGlebaId = false;
      resetTempGleba();
      changeCultura(vm.data.cultura, null);
    }

    function cancelEditAdubo() {
      vm.data.adubacao[vm.editAduboId]._edit = false;
      vm.editAduboId = false;
      resetTempAdubo();
    }

    function resetTempGleba() {
      vm.tempGleba = {
        adubo: null,
        cultivar: null,
        area_aplicada: null,
        data_inicio: null,
        ts: 'none',
        densidade: null,
        pms: null,
        pg: null,
        ciclo: null,
        dose: null,
        _id: _.uniqueId('tempGlebaId_')
      };
    }

    function resetTempAdubo() {
      for (const key in vm.tempAdubacao) {
        vm.tempAdubacao[key] = null;
      }
    }

    function getMaxMinCoordinates(glebas) {
      const allCoordinates = _.flattenDepth(glebas.map(({ gleba: { coordinates } }) => coordinates), 2);

      const min = allCoordinates.reduce((result, current) => (
        [
          Math.min(result[0], current[0]),
          Math.min(result[1], current[1])
        ]
      ), [Infinity, Infinity]);

      const max = allCoordinates.reduce((result, current) => (
        [
          Math.max(result[0], current[0]),
          Math.max(result[1], current[1])
        ]
      ), [-Infinity, -Infinity]);

      return { min, max };
    }

    function getPolygonZoom(coordinatesSize) {
      const svg = angular.element('#svg-polygons')[0];

      const svgHeight = svg.getAttribute('height').replace(/[^0-9.]/g, '');
      const svgWidth = svg.getAttribute('width').replace(/[^0-9.]/g, '');

      const pathHeight = (coordinatesSize.max[1] - coordinatesSize.min[1]);
      const pathWidth = (coordinatesSize.max[0] - coordinatesSize.min[0]);

      const zoom = (Math.min((svgHeight / pathHeight), (svgWidth / pathWidth)));
      return zoom;
    }

    function setSvgPolygon() {
      const { point, Polygon } = window['@flatten-js/core'];

      vm.svgPolygons = '';
      const pointSize = getMaxMinCoordinates(vm.data.glebas);
      const zoom = getPolygonZoom(pointSize);

      vm.data.glebas.forEach((gleba) => {
        gleba.gleba.coordinates.forEach((coordinate) => {
          const polygon = new Polygon();

          const polygonPoints = coordinate.map((points) => {
            const x = ((points[0] - pointSize.min[0]) * zoom);
            const y = ((points[1] - pointSize.min[1]) * zoom);
            return point(x, y);
          });

          polygon.addFace(polygonPoints);

          let color = '#FFF';
          if (getGlebaCultivares(gleba.gleba.id)) {
            color = getGlebaColor(gleba);
          }

          vm.svgPolygons += polygon.svg({ fill: color, strokeWidth: 2 });
        });
      });
    }

    // TODO: rever
    // eslint-disable-next-line max-lines-per-function
    function createMap() {
      if (vm.data.propriedade && vm.data.propriedade.id) {
        if (!vm.map) {
          $timeout(function() {
            GoogleMapsService.createMapForPropriedade('recommendation_map', vm.data.propriedade).then(function(result) {
              vm.map = result;
              window.dispatchEvent(new CustomEvent('resize'));
              $timeout(function() {
                const bounds = new google.maps.LatLngBounds();
                Object.keys(vm.map.polygons).forEach(function(key) {
                  GoogleMapsService.addMarkerLabelToPolygon(vm.map.polygons[key]);
                  bounds.extend(vm.map.polygons[key].bounds.getNorthEast());
                  bounds.extend(vm.map.polygons[key].bounds.getSouthWest());
                });
                configureMap();
              }, 500);
            }, 100);
          });
        } else {
          MapaService.setToMap(Object.values(vm.map.polygons), null);
          const polygons = GoogleMapsService.getPolygons(vm.data.propriedade, vm.map.map);
          const bounds = new google.maps.LatLngBounds();
          Object.keys(polygons).forEach(function(key) {
            GoogleMapsService.addMarkerLabelToPolygon(polygons[key]);
            bounds.extend(polygons[key].bounds.getNorthEast());
            bounds.extend(polygons[key].bounds.getSouthWest());
          });
          vm.map.polygons = polygons;
          vm.map.bounds = bounds;
          configureMap();
          $timeout(function() {
            window.dispatchEvent(new CustomEvent('resize'));
            GoogleMapsService.setBounds(bounds, vm.map.map);
          }, 500);
        }
      }
    }

    function configureMap() {
      if (vm.map) {
        vm.data.glebas.forEach(changeGlebaColor);
        vm.mapLegend.length = 0;
        vm.data.glebas.forEach(function(gleba) {
          const glebaCultivares = getGlebaCultivares(gleba.gleba.id);
          const color = vm.cultivarColors[glebaCultivares];
          setMarker(gleba, color);
          setupLegend(glebaCultivares, color);
          setSvgPolygon();
        });
      }
    }

    function getGlebaColor(gleba) {
      const glebaCultivares = getGlebaCultivares(gleba.gleba.id);
      if (!vm.cultivarColors[glebaCultivares]) {
        if (Object.keys(vm.cultivarColors).length <= listColors.length - 1) {
          vm.cultivarColors[glebaCultivares] = listColors[Object.keys(vm.cultivarColors).length];
        } else {
          vm.cultivarColors[glebaCultivares] = ColorService.getRandom(Object.values(vm.cultivarColors));
        }
      }
      const color = vm.cultivarColors[glebaCultivares];
      return color;
    }

    function changeGlebaColor(gleba) {
      const glebaCultivares = getGlebaCultivares(gleba.gleba.id);
      const color = getGlebaColor(gleba);

      if (vm.map) {
        paintPolygon(gleba.gleba.id, color);
        setMarker(gleba, color);
        setupLegend(glebaCultivares, color);
      }
    }

    function getGlebaCultivares(glebaId) {
      return vm.data.glebas.reduce(function(cultivares, gleba) {
        if (gleba.gleba.id === glebaId) {
          cultivares.push(gleba.cultivar.item_id);
        }
        return cultivares;
      }, []).sort(function(a, b) {
        return a - b;
      })
        .join('|');
    }

    function paintPolygon(polygon, color, contrast) {
      vm.map.polygons[polygon].setOptions({
        strokeColor: color,
        strokeWeight: contrast ? 5 : 1,
        fillColor: color,
        fillOpacity: 0.5,
        zIndex: contrast ? 999 : 10
      });
    }

    function cultivarMouseOver(legenda) {
      const { polygons } = vm.map;
      const { cor } = legenda;

      Object.entries(polygons).map((entry) => {
        const key = entry[0];
        const value = entry[1];

        if (value.fillColor === cor) {
          paintPolygon(key, cor, true);
          vm.glebaMarkers[key].setAnimation(google.maps.Animation.BOUNCE);
          vm.glebaMarkers[key].setAnimation(null);
        }
        return [];
      });
    }

    function cultivarMouseOut(legenda) {
      const { polygons } = vm.map;
      const { cor } = legenda;

      Object.entries(polygons).map((entry) => {
        const key = entry[0];
        const value = entry[1];

        if (value.fillColor === cor) {
          paintPolygon(key, cor);
        }
        return [];
      });
    }
    function setupLegend(glebaCultivares, color) {
      const label = vm.cultivares.reduce(function(names, cultivar) {
        const arrayCultivares = glebaCultivares.split('|');
        for (let i = 0; i < arrayCultivares.length; i++) {
          if (arrayCultivares[i] === (cultivar.item_id.toString())) {
            names.push(cultivar.descricao);
          }
        }
        return names;
      }, []).join(', ');
      if (!vm.mapLegend.some(function(legend) {
        return legend.descricao === label;
      })) {
        vm.mapLegend.push({
          descricao: label,
          cor: color,
          icon: 'legenda-icon'
        });
      }
    }

    function setMarker(gleba, color) {
      const number = _.findIndex( // finds index of item in array
        _.uniqBy( // removes duplicate items
          vm.sortedGlebas(),
          'gleba.id' // uses `_.property` and filters by `item.gleba.id` to remove duplicated entries
        ),
        { gleba: { id: gleba.gleba.id } } // makes a deep comparison with the item to find its index
      );
      const polCoord = GoogleMapsService.getCoordinatesFromPolygon(vm.map.polygons[gleba.gleba.id])
        .map(function(coord) {
          return {
            latitude: coord.lat(),
            longitude: coord.lng()
          };
        });
      const centroid = MapaService.getCoordinateCentroid(polCoord);

      if (vm.glebaMarkers[gleba.gleba.id]) {
        vm.glebaMarkers[gleba.gleba.id].setMap(null);
        vm.glebaMarkers[gleba.gleba.id] = null;
      }

      vm.glebaMarkers[gleba.gleba.id] = new google.maps.Marker({
        map: vm.map.map,
        position: {
          lat: centroid.latitude,
          lng: centroid.longitude
        },
        icon: GoogleMapsService.getIconForNumberMarker(number + 1, color.substr(1),
          colorClarity(color) > 128 ? '000000' : 'ffffff')
      });
    }

    function colorClarity(color) {
      return ((parseInt(color.substr(1, 2), 16) * 299) +
        (parseInt(color.substr(2, 2), 16) * 587) +
        (parseInt(color.substr(4, 2), 16) * 114)) / 1000;
    }

    function searchCultivares($select) {
      if (!$select.search || $select.search.length < 3) {
        return;
      }

      const hasTs = vm.tempGleba.ts && vm.tempGleba.ts !== 'none';
      const filters = {
        operacao_item: 'cultivar',
        descricao: $select.search
      };

      if (hasTs) {
        filters.possui_tratamento = vm.tempGleba.ts === 'tsi';
      }

      return ItensService.listItemsBalance(filters)
        .then(function(result) {
          vm.cultivares = result.data.map((data) => ({ ...data, item_id: data.id, tipo_item: 1 }));
        })
        .catch(function(error) {
          console.error('Falha ao buscar cultivares', error);
        });
    }

    function fetchCultivaresByIds(itemIds) {
      if (!itemIds.length) {
        return $q.resolve([]);
      }

      return ItensService.listItemsBalance({
        operacao_item: 'cultivar',
        tipo_item: 1,
        item: itemIds.join(',')
      })
        .then(function(result) {
          return result.data.map((data) => ({ ...data, item_id: data.id, tipo_item: 1 }));
        })
        .catch(function(error) {
          console.error('Falha ao buscar cultivares vinculados à recomendação', error);
          return [];
        });
    }

    // eslint-disable-next-line max-lines-per-function
    function changeCultura(cultura, ts) {
      vm.isMilho = AtividadesService.isCorn(cultura.descricao);
      vm.isCulturaPorUnidade = vm.isMilho || AtividadesService.isCana(cultura.descricao);

      const hasTs = ts && ts !== 'none';
      const currentKey = hasTs ? ts : 'none';

      if (vm._cultivaresKey === currentKey) {
        getPeriodosByEmpreedimentos();
        return $q.resolve();
      }

      LoadingService.showLoading();
      vm._cultivaresKey = currentKey;

      const filters = {
        operacao_item: 'cultivar'
      };

      if (hasTs) {
        filters.possui_tratamento = ts === 'tsi';
      }

      return ItensService.listItemsBalance(filters)
        .then(async function(result) {
          vm.cultivares = result.data.map((data) => ({ ...data, item_id: data.id, tipo_item: 1 }));

          if (!vm.cultivares.length) {
            let message = 'Atenção, não existem cultivares para esta cultura';
            if (ts === 'tsi') {
              message += ' com tratamento de semente ativo';
            }
            MessagesService.alert(`${message}. Não será possível fazer a recomendação.`);
          }

          if (vm.cultivares.length && !vm.cultivaresDestino.length) {
            const cultivaresResult = await ItensService.listCultivares();
            vm.cultivaresDestino = cultivaresResult.data.filter((cultivar) => {
              const index = vm.cultivares.findIndex(
                (cultivarDestino) => cultivar.codigo_semente_origem === cultivarDestino.id
              );
              return index !== -1;
            });
          }
          getPeriodosByEmpreedimentos();
        })
        .catch(function(error) {
          vm._cultivaresKey = null;
          console.error('Falha ao carregar cultivares', error);
        })
        .finally(LoadingService.hideLoading);
    }

    function getPeriodosByEmpreedimentos() {
      if (vm.nao_cliente_agrogestao) {
        vm.empreendimentos_periodos = vm.periodos;
        return;
      }

      if (!vm.data.safra || !vm.data.propriedade || !vm.data.cultura) {
        vm.empreendimentos_periodos = [];
        return;
      }

      LoadingService.showLoading();
      const params = {
        safra: vm.data.safra.id,
        propriedade: vm.data.propriedade.id,
        atividade: vm.data.cultura.id
      };

      return EmpreendimentosService.list(params)
        .then(async function(result) {
          if (!result.data.length) {
            vm.empreendimentos_periodos = [];
            return;
          }

          const periodosIds = result.data.map((empr) => empr.cd_periodo);

          vm.empreendimentos_periodos = vm.periodos.filter((p) => periodosIds.includes(p.codigo));
        })
        .catch(function(error) {
          console.error('Falha ao carregar períodos', error);
        })
        .finally(LoadingService.hideLoading);
    }

    function sortedGlebas() {
      return vm.data.glebas.slice().sort(function(a, b) {
        if (a.data_inicio === b.data_inicio) {
          if (a.gleba.descricao > b.gleba.descricao) {
            return 1;
          }
          if (a.gleba.descricao < b.gleba.descricao) {
            return -1;
          }
          return 0;
        }
        return moment(a.data_inicio) - moment(b.data_inicio);
      });
    }

    function shouldActiveTab(name) {
      if (name === 'glebas') {
        return vm.data.propriedade && vm.data.cultura;
      }

      if (name === 'tratamento') {
        return _possuiTratamento();
      }

      return true;

      function _possuiTratamento() {
        const possuiTratamento = vm.data.glebas.filter(function(gleba) {
          return gleba.ts !== 'nenhum';
        });
        return possuiTratamento.length;
      }
    }

    function listCultivaresParaTratar() {
      vm.cultivaresTratamento = RecomendacoesSemeaduraService.listCultivaresParaTratar(vm.data.glebas);
      vm.cultivaresDestinoTratamento = vm.cultivaresDestino.filter((cultivarDestino) => {
        const index = vm.cultivaresTratamento
          .findIndex((cultivarOrigem) => cultivarOrigem.item_id === cultivarDestino.codigo_semente_origem);
        return index !== -1;
      });

      RecomendacoesSemeaduraService.autoFillCultivaresDestino(vm.data.tratamentos, vm.cultivaresDestinoTratamento);
    }

    function changeCobertura(active) {
      if (active) {
        const fields = ['espacamento', 'densidade', 'area_remontes', 'quantidade', 'regulagem', 'regulagem_adubacao'];
        fields.forEach((field) => vm.data[field] = null);
        vm.data.calculo_margem_seguranca = false;
      }
    }

    function totalInsumoPorCultivar(produto, tratamento) {
      const totalKg =
        tratamento.totalKg ||
        tratamento.totalKgTSI ||
        tratamento.cultivar.totalKg ||
        tratamento.cultivar.totalKgTSI;

      return produto.dose * totalKg / (vm.isCulturaPorUnidade ? 1 : 100);
    }

    function checkTratamentosCultivares() {
      const cultivaresGlebas = _.uniq(_.map(vm.data.glebas || [], 'cultivar.item_id'));
      const cultivaresTratamentos = _.uniq(_.map(vm.data.tratamentos || [], 'cultivar.item_id'));
      const difference = cultivaresTratamentos.filter(function(item) {
        return !cultivaresGlebas.includes(item);
      });

      if (difference.length) {
        const groupBy = _.groupBy(vm.data.tratamentos, 'cultivar.item_id');
        const descriptions = difference.map(function(diffId) {
          return groupBy[diffId][0].cultivar.descricao;
        });
        MessagesService.alert(
          `Existem tratamentos para cultivares que não estão mais sendo recomendadas: ${descriptions.join(',')}`
        );
        return false;
      }

      return true;
    }

    function reduceInsumos() {
      return vm.data.tratamentos.reduce((group, tratamento) => {
        tratamento.insumos.forEach((insumo) => {
          let groupInsumo = _.find(group, { descricao: insumo.descricao });
          if (!groupInsumo) {
            groupInsumo = {
              descricao: insumo.descricao,
              total: totalInsumoPorCultivar(insumo, tratamento),
              unidade: insumo.unidadeSelected.abreviatura
            };
            return group.push(groupInsumo);
          }
          groupInsumo.total += totalInsumoPorCultivar(insumo, tratamento);
        });
        return group;
      }, []);
    }

    function isEditingGleba() {
      return vm.data.glebas.some((gleba) => gleba._edit);
    }

    //////////////////////////////////////////
    // Controller logic

    // show loading screen
    LoadingService.showLoading();

    resetTempGleba();

    // eslint-disable-next-line max-lines-per-function
    $rootScope.initialize.then(function() {
      // redirects to home if unallowed
      if (!$rootScope.permissions.recomendacaoSemeadura.canManage) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
      } else {
        // get loaded propriedades
        vm.propriedades = $rootScope.propriedades.map(function(propriedade) {
          return {
            area_total: propriedade.area_total,
            descricao: propriedade.descricao,
            glebas: propriedade.glebas,
            id: propriedade.id
          };
        });

        if ($rootScope.currentPropriedade) {
          vm.data.propriedade = vm.propriedades.find(function(propriedade) {
            return $rootScope.currentPropriedade.id === propriedade.id;
          });
        }

        // load new data
        // promises to be resolved from loading services
        const promises = [
          AtividadesService.listComEmpreendimento(),
          ItensService.listAdubos(),
          SafrasService.listAll(),
          ParametrosService.get(),
          PeriodosService.list()
        ];

        // if editing existing recommendation
        if (id) {
          promises.push(RecomendacoesSemeaduraService.get(id));
        }

        // resolves all promises
        // eslint-disable-next-line max-lines-per-function
        $q.all(promises).then(function(results) {
          vm.cliente_nao_agrogestao = $scope.$root.parametros.nao_cliente_agrogestao;
          // get loaded culturas
          vm.culturas = results[0].data;
          // get loaded adubos
          vm.adubos = results[1].data;
          // get loaded safras
          vm.safras = results[2].data;
          // get loaded periodos
          vm.periodos = results[4].data;

          vm.safras.forEach(function(safra) {
            if (safra.current && !id) {
              vm.data.safra = safra;
            }
          });
          if (results[3].data.imagem && results[3].data.imagem.imagem_report_url) {
            vm.logo = SERVER + results[3].data.imagem.imagem_report_url;
          }

          function findPeriodo(periodo) {
            if (!vm.data.periodo) {
              return false;
            }

            return periodo.codigo === vm.data.periodo.codigo;
          }

          // if editing, get current data
          if (id) {
            const cultivarIds = _.uniq((results[5].data.cultivares || []).map(function(cultivarVinculado) {
              return cultivarVinculado.insumo_id;
            }));
            const editPromises = [changeCultura(results[5].data.atividade), fetchCultivaresByIds(cultivarIds)];

            $q.all(editPromises).then(function(resolved) {
              vm.cultivares = _.uniqBy(vm.cultivares.concat(resolved[1]), 'item_id');
              // convert loaded restults to required formatted object
              vm.data = RecomendacoesSemeaduraObjectService.convertToObject(results[5].data, vm.cultivares, vm.adubos);
              vm.data.periodo = vm.periodos.find(findPeriodo) || vm.data.periodo;
              vm.data.safra = vm.safras.find(function(safra) {
                return safra.id === vm.data.safra;
              }) || vm.data.safra;
              vm.data.propriedade = vm.propriedades.filter(function(propriedade) {
                return propriedade.id === vm.data.propriedade.id;
              })[0];

              vm.data.glebas.forEach(function(gleba) {
                gleba._id = _.uniqueId('glebaId_');
                gleba.gleba = vm.data.propriedade.glebas.find((glebaPropriedade) => (
                  glebaPropriedade.id === gleba.gleba.id
                ));
              });
              vm.calcDensidade('all');
              vm.calcQuantidadeTotalAdubo('all');
              vm.calcDuracao('all');
              vm.listCultivaresParaTratar();
              vm.data.tratamentos = RecomendacoesSemeaduraService
                .getTotaisTratamento(vm.cultivaresTratamento, vm.data.tratamentos);
              vm.reducedInsumos = reduceInsumos();
              if (printRecomedacao) {
                $timeout(function() {
                  $('#print-btn').click();
                });
              }
              getPeriodosByEmpreedimentos();
            })
              .catch(function(error) {
                MessagesService.alert('Falha ao carregar dados, tente novamente.');
                console.error(error);
              });
          } else {
            LoadingService.hideLoading();
          }
        })
          .catch(function(error) {
            // show error message on load fail
            MessagesService.alert('Falha ao carregar dados, tente novamente.');
            console.error(error);
          });
      }
    }, $rootScope.errorRootInitialize);

    // TODO: complexity
    // eslint-disable-next-line complexity
    $scope.$watch('recomendacaoSemeadura.tempGleba.gleba', function() {
      if (vm.tempGleba && vm.tempGleba.gleba && !vm.tempGleba.area_aplicada) {
        const sum = vm.data.glebas.slice().concat([vm.tempGleba])
          .reduce(function(last, current) {
            last += (current.gleba.id === vm.tempGleba.gleba.id) ? (+current.area_aplicada) : 0;
            return last;
          }, 0);

        const diff = Math.round(((+vm.tempGleba.gleba.area_total) - sum) * 100) / 100;

        if (diff > 0) {
          vm.tempGleba.area_aplicada = diff;
        }
        vm.tempGleba.data_fim_max = null;
      }
      if (vm.tempGleba.gleba) {
        if (!vm.tempGleba.data_inicio) {
          const sorted = _.orderBy(vm.data.glebas, (gleba) => moment(gleba.data_fim_max).format('YYYYMMDD'), ['asc']);

          const last = _.last(sorted);

          if (last && last.data_fim_max) {
            vm.tempGleba.data_inicio = moment(last.data_fim_max).toDate();
          }
        }
        if (!vm.tempGleba.data_fim_max) {
          vm.calcDuracao(vm.tempGleba);//recalcula a data final máxima para preencher o input de data
        }
      }
    });

    // TODO: complexity
    // eslint-disable-next-line complexity
    $scope.$watch('recomendacaoSemeadura.tempGleba.cultivar', function() {
      if (vm.tempGleba.cultivar && vm.data.glebas.length > 0) {
        const last = vm.data.glebas.filter(function(gleba) {
          return gleba.cultivar.item_id === vm.tempGleba.cultivar.item_id;
        }).shift();

        if (last) {
          if (last.densidade && !vm.tempGleba.densidade) {
            vm.tempGleba.densidade = last.densidade;
          }
          if (last.pms && !vm.tempGleba.pms) {
            vm.tempGleba.pms = last.pms;
          }
          if (last.pg && !vm.tempGleba.pg) {
            vm.tempGleba.pg = last.pg;
          }
          if (last.ciclo && !vm.tempGleba.ciclo) {
            vm.tempGleba.ciclo = last.ciclo;
          }
        }
      }
    });

    $scope.$watch('recomendacaoSemeadura.data.tratamentos', () => {
      vm.reducedInsumos = reduceInsumos();
    }, true);

    $scope.$watch('recomendacaoSemeadura.tempAdubacao.gleba', function(newValue, oldValue) {
      if (newValue) {
        const areaAplicada = newValue.areaAplicadaAcumulada ||
          parseFloat((+newValue.area_aplicada).toFixed(2));
        vm.tempAdubacao.area = areaAplicada;
      }
      if (oldValue) { //reseta o valor acumulado
        oldValue.areaAplicadaAcumulada = null;
      }
    });

    $scope.$watch('recomendacaoSemeadura.data.area_remontes', listCultivaresParaTratar);
  }
}());
